// extracted by mini-css-extract-plugin
module.exports = {"container":"discount-alert-module__container___Xw6XR","amount":"discount-alert-module__amount___frhXl","subtitle":"discount-alert-module__subtitle___NJrdF"};